<template>

  <div>
    <b-card no-body  id="listEvaluaciones" >

      <div class="m-2">

        <!-- Table Top -->
        <b-row>

          <!-- Per Page -->
          <b-col
              cols="12"
              lg="8"
              class="d-flex align-items-center justify-content-start mb-1 mb-lg-0"
          >
            <b-button
                variant="gradient-secondary"
                class="mr-1"
                @click="traerEvaluaciones"
            >
              <feather-icon
                  icon="RefreshCwIcon"
                  :class="`${loading ? 'spinner' : ''}`"
              />
            </b-button>
            <b-button
                variant="gradient-primary"
                class="mr-lg-5"
                @click="exportarFileV2"
                :disabled="loading_exp"
            >
              <feather-icon
                  :icon="`${loading_exp ? 'RefreshCwIcon' : 'FileTextIcon'}`"
                  :class="`${loading_exp ? 'spinner' : ''}`"
              />
              <span v-if="loading_exp">Generando Excel</span>
            </b-button>

            <label>Filtro Fecha: </label>

            <b-input-group>
              <flat-pickr
                  v-model="fechaFiltro"
                  class="form-control"
                  :config="{wrap: true, mode: 'range', dateFormat: 'd/m/Y', locale: 'es', maxDate: new Date()}"

                  @on-change="realizarFiltro('fecha', [fechaFiltro])"
              />
              <b-input-group-append>
                <b-button
                    variant="gradient-danger"
                    @click="realizarFiltro('fecha', [])"
                >
                  <feather-icon
                      icon="Trash2Icon"
                  />
                </b-button>
              </b-input-group-append>
            </b-input-group>


          </b-col>

          <!-- Search -->
          <b-col
              cols="12"
              lg="4"
          >
            <div class="d-flex align-items-center justify-content-end">
              <b-input-group>
                <b-form-input
                    id="filterInput"
                    v-model="filter"
                    type="search"
                    placeholder="Buscar"
                />
                <b-input-group-append>
                  <b-button
                      :disabled="!filter"
                      @click="filter = ''"
                  >
                    Borrar
                  </b-button>
                </b-input-group-append>
              </b-input-group>
            </div>
          </b-col>
        </b-row>

      </div>

      <b-table
          hover
          responsive
          small
          sticky-header="58vh"
          class="position-relative tablitabs"
          :items="itemsFiltro"
          :fields="fields"
          :sort-by.sync="sortBy"
          :sort-desc.sync="sortDesc"
          :sort-direction="sortDirection"
          :filter="filter"
          :filter-included-fields="filterOn"
          :busy="loading"
          show-empty
          empty-text="No se encontraron datos en esta tabla."
          emptyFilteredText="No se encontraron datos con los parámetros ingresados."
          id="table-evaluaciones"
      >
        <template #table-busy>
          <div class="text-center text-dark my-1">
            <b-spinner class="align-middle"></b-spinner> &emsp;
            <strong>Obteniendo datos...</strong>
          </div>
        </template>

        <template #head(empresa)>
          <div class="text-nowrap">
            <b-dropdown
                menu-class=""
                size="sm"
                variant="btn"
                :toggle-class="`${empresa_filtro.length>0 ? 'text-primary font-weight-bolder p-1' : 'font-weight-bolder p-1'}`"
                :style="`${empresa_filtro.length>0 ? 'text-decoration: underline #fba820e6;' : ''}`"
            >
              <template #button-content>
                <b>EMPRESA</b>
              </template>
              <b-dropdown-form >
                <b-form-group label="Filtrar empresa" label-for="empresa_filtro" @click.prevent class="py-0 my-0">
                  <v-select
                      id="empresa_filtro"
                      v-model="empresa_filtro"
                      :options="empresaFiltro"
                      multiple
                      placeholder="Seleccionar empresa ..."
                      @input="realizarFiltro('empresa', empresa_filtro)"
                      class="select-size-sm"
                  />
                </b-form-group>
              </b-dropdown-form>
              <b-dropdown-divider></b-dropdown-divider>
              <b-dropdown-item @click="empresa_filtro=[]; realizarFiltro('empresa', [])">
                <feather-icon class="mr-1" icon="DeleteIcon" />
                <span class="align-middle ml-50">Borrar Filtro</span>
              </b-dropdown-item>
            </b-dropdown>
          </div>
        </template>

        <template #head(fundo)>
          <div class="text-nowrap">
            <b-dropdown
                menu-class=""
                size="sm"
                variant="btn"
                :toggle-class="`${fundo_filtro.length>0 ? 'text-primary font-weight-bolder p-1' : 'font-weight-bolder p-1'}`"
                :style="`${fundo_filtro.length>0 ? 'text-decoration: underline #fba820e6;' : ''}`"
            >
              <template #button-content>
                <b>FUNDO</b>
              </template>
              <b-dropdown-form >
                <b-form-group label="Filtrar fundo" label-for="fundo_filtro" @click.prevent class="py-0 my-0">
                  <v-select
                      id="fundo_filtro"
                      v-model="fundo_filtro"
                      :options="fundoFiltro"
                      multiple
                      placeholder="Seleccionar fundo ..."
                      @input="realizarFiltro('fundo', fundo_filtro)"
                      class="select-size-sm"
                  />
                </b-form-group>
              </b-dropdown-form>
              <b-dropdown-divider></b-dropdown-divider>
              <b-dropdown-item @click="fundo_filtro=[]; realizarFiltro('fundo', [])">
                <feather-icon class="mr-1" icon="DeleteIcon" />
                <span class="align-middle ml-50">Borrar Filtro</span>
              </b-dropdown-item>
            </b-dropdown>
          </div>
        </template>

        <template #head(etapa)>
          <div class="text-nowrap">
            <b-dropdown
                menu-class=""
                size="sm"
                variant="btn"
                :toggle-class="`${etapa_filtro.length>0 ? 'text-primary font-weight-bolder p-1' : 'font-weight-bolder p-1'}`"
                :style="`${etapa_filtro.length>0 ? 'text-decoration: underline #fba820e6;' : ''}`"
            >
              <template #button-content>
                <b>ETAPA</b>
              </template>
              <b-dropdown-form >
                <b-form-group label="Filtrar etapa" label-for="etapa_filtro" @click.prevent class="py-0 my-0">
                  <v-select
                      id="etapa_filtro"
                      v-model="etapa_filtro"
                      :options="etapaFiltro"
                      multiple
                      placeholder="Seleccionar etapa ..."
                      @input="realizarFiltro('etapa', etapa_filtro)"
                      class="select-size-sm"
                  />
                </b-form-group>
              </b-dropdown-form>
              <b-dropdown-divider></b-dropdown-divider>
              <b-dropdown-item @click="etapa_filtro=[]; realizarFiltro('etapa', [])">
                <feather-icon class="mr-1" icon="DeleteIcon" />
                <span class="align-middle ml-50">Borrar Filtro</span>
              </b-dropdown-item>
            </b-dropdown>
          </div>
        </template>

        <template #head(campo_area)>
          <div class="text-nowrap">
            <b-dropdown
                menu-class=""
                size="sm"
                variant="btn"
                :toggle-class="`${campo_filtro.length>0 ? 'text-primary font-weight-bolder p-1' : 'font-weight-bolder p-1'}`"
                :style="`${campo_filtro.length>0 ? 'text-decoration: underline #fba820e6;' : ''}`"
            >
              <template #button-content>
                <b>CAMPO / ÁREA</b>
              </template>
              <b-dropdown-form >
                <b-form-group label="Filtrar campo" label-for="campo_filtro" @click.prevent class="py-0 my-0">
                  <v-select
                      id="campo_filtro"
                      v-model="campo_filtro"
                      :options="campoFiltro"
                      multiple
                      placeholder="Seleccionar campo ..."
                      @input="realizarFiltro('campo_area', campo_filtro)"
                      class="select-size-sm"
                  />
                </b-form-group>
              </b-dropdown-form>
              <b-dropdown-divider></b-dropdown-divider>
              <b-dropdown-item @click="campo_filtro=[]; realizarFiltro('campo_area', [])">
                <feather-icon class="mr-1" icon="DeleteIcon" />
                <span class="align-middle ml-50">Borrar Filtro</span>
              </b-dropdown-item>
            </b-dropdown>
          </div>
        </template>

        <template #head(zona_inspeccion)>
          <div class="text-nowrap">
            <b-dropdown
                menu-class=""
                size="sm"
                variant="btn"
                :toggle-class="`${zona_filtro.length>0 ? 'text-primary font-weight-bolder p-1' : 'font-weight-bolder p-1'}`"
                :style="`${zona_filtro.length>0 ? 'text-decoration: underline #fba820e6;' : ''}`"
            >
              <template #button-content>
                <b>ZONA INSPECC.</b>
              </template>
              <b-dropdown-form >
                <b-form-group label="Filtrar zona" label-for="zona_filtro" @click.prevent class="py-0 my-0">
                  <v-select
                      id="zona_filtro"
                      v-model="zona_filtro"
                      :options="zonaFiltro"
                      multiple
                      placeholder="Seleccionar zona ..."
                      @input="realizarFiltro('zona_inspeccion', zona_filtro)"
                      class="select-size-sm"
                  />
                </b-form-group>
              </b-dropdown-form>
              <b-dropdown-divider></b-dropdown-divider>
              <b-dropdown-item @click="zona_filtro=[]; realizarFiltro('zona_inspeccion', [])">
                <feather-icon class="mr-1" icon="DeleteIcon" />
                <span class="align-middle ml-50">Borrar Filtro</span>
              </b-dropdown-item>
            </b-dropdown>
          </div>
        </template>

        <template #head(area)>
          <div class="text-nowrap">
            <b-dropdown
                menu-class=""
                size="sm"
                variant="btn"
                :toggle-class="`${area_filtro.length>0 ? 'text-primary font-weight-bolder p-1' : 'font-weight-bolder p-1'}`"
                :style="`${area_filtro.length>0 ? 'text-decoration: underline #fba820e6;' : ''}`"
            >
              <template #button-content>
                <b>ÁREA</b>
              </template>
              <b-dropdown-form >
                <b-form-group label="Filtrar area" label-for="area_filtro" @click.prevent class="py-0 my-0">
                  <v-select
                      id="area_filtro"
                      v-model="area_filtro"
                      :options="areaFiltro"
                      multiple
                      placeholder="Seleccionar area ..."
                      @input="realizarFiltro('area', area_filtro)"
                      class="select-size-sm"
                  />
                </b-form-group>
              </b-dropdown-form>
              <b-dropdown-divider></b-dropdown-divider>
              <b-dropdown-item @click="area_filtro=[]; realizarFiltro('area', [])">
                <feather-icon class="mr-1" icon="DeleteIcon" />
                <span class="align-middle ml-50">Borrar Filtro</span>
              </b-dropdown-item>
            </b-dropdown>
          </div>
        </template>

        <template #head(con_evaluador)>
          <div class="text-nowrap">
            <b-dropdown
                menu-class=""
                size="sm"
                variant="btn"
                :toggle-class="`${evaluador_filtro.length>0 ? 'text-primary font-weight-bolder p-1' : 'font-weight-bolder p-1'}`"
                :style="`${evaluador_filtro.length>0 ? 'text-decoration: underline #fba820e6;' : ''}`"
            >
              <template #button-content>
                <b>EVALUADOR</b>
              </template>
              <b-dropdown-form >
                <b-form-group label="Filtrar evaluador" label-for="evaluador_filtro" @click.prevent class="py-0 my-0">
                  <v-select
                      id="evaluador_filtro"
                      v-model="evaluador_filtro"
                      :options="evaluadorFiltro"
                      :reduce="evaluadorFiltro => evaluadorFiltro.id"
                      label="nombres"
                      multiple
                      placeholder="Seleccionar evaluador ..."
                      @input="realizarFiltro('con_evaluador', evaluador_filtro)"
                      class="select-size-sm"
                  />
                </b-form-group>
              </b-dropdown-form>
              <b-dropdown-divider></b-dropdown-divider>
              <b-dropdown-item @click="evaluador_filtro=[]; realizarFiltro('con_evaluador', [])">
                <feather-icon class="mr-1" icon="DeleteIcon" />
                <span class="align-middle ml-50">Borrar Filtro</span>
              </b-dropdown-item>
            </b-dropdown>
          </div>
        </template>

        <template #cell(fecha)="data">
        <span class="text-nowrap">
          {{
            new Date(data.value.split('-')).toLocaleString('pe-PE', {
              year: 'numeric',
              month: '2-digit',
              day: '2-digit',
              localeMatcher: 'best fit',
              timeZone: 'America/Lima'
            })
          }}
        </span>
        </template>

        <template #cell(estado)="data">
          <b-badge :variant="status[1][data.value]">
            {{ status[0][data.value] }}
          </b-badge>
        </template>
        <template #cell(con_evaluador)="data">
          <span class="text-nowrap">{{data.value.apellidos}}, {{data.value.nombres}}</span>
        </template>
        <template #cell(n_categorias)="data">
          <feather-icon
              :id="`btn_${data.item.id}_vercategoria`"
              icon="EyeIcon"
              class="text-primary mr-50"
              size="18"
              @click="verCagetorias(data.item)"
          />
          <span class="text-nowrap">{{data.value}}</span>
        </template>

        <template #cell(firma_responsable)="data" >
          <div v-if="data.item.firma_responsable">
            <div class="text-nowrap">
              <feather-icon
                  :id="`btn_${data.item.id}_ver`"
                  icon="ImageIcon"
                  size="16"
                  class="text-info mx-1"
                  @click="verFirma(data.item.firma_responsable)"
              />
            </div>
          </div>
          <div style="color: red" v-else >
            <!--NO -->
          </div>


        </template>

      </b-table>

      <!--
      <b-card-body class="d-flex justify-content-between flex-wrap pt-0">
        &lt;!&ndash; page length &ndash;&gt;
        <b-form-group
            label="Mostrar"
            label-cols="5"
            label-align="left"
            label-size="sm"
            label-for="sortBySelect"
            class="text-nowrap mb-md-0 mr-1"
        >
          <b-form-select
              id="perPageSelect2"
              v-model="perPage"
              size="sm"
              inline
              :options="pageOptions"
          />

        </b-form-group>

        &lt;!&ndash; pagination &ndash;&gt;
        <div>
          <b-pagination
              v-model="currentPage"
              :total-rows="totalRows"
              :per-page="perPage"
              first-number
              last-number
              prev-class="prev-item"
              next-class="next-item"
              class="mb-0"
          >
            <template #prev-text>
              <feather-icon
                  icon="ChevronLeftIcon"
                  size="18"
              />
            </template>
            <template #next-text>
              <feather-icon
                  icon="ChevronRightIcon"
                  size="18"
              />
            </template>
          </b-pagination>
        </div>
      </b-card-body>
      -->

    </b-card>
    <b-card no-body  style="display: none" id="listCategorias"  >
      <b-card-body>
        <div class="d-flex justify-content-between  flex-wrap">
          <!-- Registar Empresa  -->

          <b-form-group
              label-for="filterInput"
              class="mb-0"
          >
            <b-button
                variant="gradient-danger"
                size="sm"
                class="mr-1"
                @click="regresarInicio"
            >
              <feather-icon
                  icon="ArrowLeftIcon"
              />
              Regresar
            </b-button>

            <b>Lista de Categorias</b>
          </b-form-group>
          <!-- filter -->
          <b-form-group
              label-for="ilter_categoriaInput"
              class="mb-0"
          >
            <b-input-group size="sm">
              <b-form-input
                  id="filter_categoriaInput"
                  v-model="filter_categoria"
                  type="search"
                  placeholder="Buscar"
              />
              <b-input-group-append>
                <b-button
                    :disabled="!filter_categoria"
                    @click="filter_categoria = ''"
                >
                  Borrar
                </b-button>
              </b-input-group-append>
            </b-input-group>
          </b-form-group>

        </div>
      </b-card-body>

      <b-table
          hover
          responsive
          small
          sticky-header="58vh"
          class="position-relative tablitabs"
          :current-page="currentPage_c"
          :items="itemsCategorias"
          :fields="fieldsCategorias"
          :sort-by.sync="sortBy_c"
          :sort-desc.sync="sortDesc_c"
          :sort-direction="sortDirection_c"
          :filter="filter_categoria"
          :filter-included-fields="filterOnCategoria"
          @filtered="cPaginacion_c"
          :busy="loading_c"
          show-empty
          empty-text="No se encontraron datos en esta tabla."
          id="table-categorias"
      >
        <template #table-busy>
          <div class="text-center text-dark my-1">
            <b-spinner class="align-middle"></b-spinner> &emsp;
            <strong>Obteniendo datos...</strong>
          </div>
        </template>

        <template #cell(fecha_lo)="data">
        <span class="text-nowrap" v-if="data.value !== ''">
          {{
            new Date(data.value).toLocaleString('pe-PE', {
              year: 'numeric',
              month: '2-digit',
              day: '2-digit',
              localeMatcher: 'best fit',
              timeZone: 'America/Lima'
            })
          }}
        </span>
        </template>
        <template #cell(estado)="data">
          <b-badge :variant="status[1][data.value]">
            {{ status[0][data.value] }}
          </b-badge>
        </template>
        <template #cell(con_evaluador)="data">
          <span class="text-nowrap">{{data.value.apellidos}}, {{data.value.nombres}}</span>
        </template>
        <template #cell(fotos)="data">
          <feather-icon
              :id="`btn_${data.item.id}_verfoto`"
              icon="ImageIcon"
              class="text-primary mr-50"
              size="18"
              @click="verFotos(data.value)"
              v-b-tooltip.hover="'Ver Foto'"
          />
          <span class="text-nowrap">{{data.value.length}}</span>
        </template>
      </b-table>

      <b-card-body class="d-flex justify-content-between flex-wrap pt-0">
        <!-- page length -->
        <!-- <b-form-group
            label="Mostrar"
            label-cols="5"
            label-align="left"
            label-size="sm"
            label-for="sortBySelect"
            class="text-nowrap mb-md-0 mr-1"
        >
          <b-form-select
              id="perPageSelect2_c"
              v-model="perPage_c"
              size="sm"
              inline
              :options="pageOptions_c"
          />

        </b-form-group> -->

        <!-- pagination -->
        <!-- <div>
          <b-pagination
              v-model="currentPage_c"
              :total-rows="totalRowsCategoria"
              :per-page="perPage_c"
              first-number
              last-number
              prev-class="prev-item"
              next-class="next-item"
              class="mb-0"
          >
            <template #prev-text>
              <feather-icon
                  icon="ChevronLeftIcon"
                  size="18"
              />
            </template>
            <template #next-text>
              <feather-icon
                  icon="ChevronRightIcon"
                  size="18"
              />
            </template>
          </b-pagination>
        </div> -->
      </b-card-body>

    </b-card>

    <b-modal
        id="modalRegistro"
        v-model="estadoModal"
        :ok-title="infoModal.boton"
        ok-only
        ok-title="Aceptar"
        :title="`Total de Fotos: ${this.fotos.length}`"
        scrollable
    >
      <b-row>
        <b-col
            v-for="(item, index) in this.fotos"
            :key="item.id"
            lg="12"
        >
          <b-card
              :img-src="item.file"
              overlay
              text-variant="white"
              img-alt="card img"
              body-class=""
          >
          </b-card>
        </b-col>
      </b-row>
    </b-modal>

    <b-modal
        id="modalRegistroFirma"
        v-model="estadoModalFirma"
        :ok-title="infoModal.boton"
        ok-only
        ok-title="Aceptar"
        :title="`Firma`"
        scrollable
    >
      <b-row>
        <b-col
            lg="12"
        >
          <b-card
              :img-src="fotosFirma"
              overlay
              text-variant="white"
              img-alt="card img"
              body-class=""
          >
          </b-card>
        </b-col>
      </b-row>
    </b-modal>

  </div>


</template>

<script>
import axiosIns from '../../libs/axios'
import Ripple from 'vue-ripple-directive'
import vSelect from 'vue-select'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import flatPickr from 'vue-flatpickr-component'
import { Spanish } from "flatpickr/dist/l10n/es.js"

import {
  BAvatar,
  BBadge,
  BButton,
  BCard,
  BCardBody,
  BCol,
  BDropdown,
  BDropdownDivider,
  BDropdownForm,
  BDropdownHeader,
  BDropdownItem,
  BFormGroup,
  BFormInput,
  BFormSelect,
  BInputGroup,
  BInputGroupAppend,
  BLink,
  BListGroup,
  BListGroupItem,
  BModal,
  BPagination,
  BRow,
  BSpinner,
  BTable,
  BTooltip,
  VBModal, VBTooltip,
} from 'bootstrap-vue'

export default {
  components: {
    BCard,
    BTable,
    BAvatar,
    BBadge,
    BFormGroup,
    BFormSelect,
    BPagination,
    BInputGroup,
    BFormInput,
    BInputGroupAppend,
    BButton,
    BCardBody,
    BTooltip,
    BModal,
    VBModal,
    BListGroup,
    BListGroupItem,
    BRow,
    BCol,
    vSelect,
    ToastificationContent,
    BSpinner,
    BLink,
    BDropdown, BDropdownForm, BDropdownItem, BDropdownHeader, BDropdownDivider,
    flatPickr,
  },
  directives: {
    'b-modal': VBModal,
    'b-tooltip': VBTooltip,
    Ripple,
  },
  data() {
    return {
      // perPage: 10,
      // perPage_c: 10,
      // pageOptions: [10, 15, 20],
      // pageOptions_c: [10, 15, 20],
      totalRows: 1,
      totalRowsCategoria:1,
      currentPage: 1,
      currentPage_c: 1,
      sortBy: 'id',
      sortBy_c: 'id_c',
      sortDesc: true,
      sortDesc_c: true,
      sortDirection: 'desc',
      sortDirection_c: 'desc',
      filter: null,
      filter_categoria :null,
      filterOn: [],
      filterOnCategoria: [],
      estadoModal: false,
      estadoModalFirma:false,
      infoModal: {
        title: '',
        boton: '',
      },
      fields: [
        {
          key: 'empresa',
          label: 'Empresa',
          thClass: 'p-1 text-center alinear-medio',
          tdClass: 'alinear-una-sola-linea px-1',
          sortable: true
        },
        {
          key: 'fundo',
          label: 'Fundo',
          thClass: 'p-1 text-center alinear-medio',
          tdClass: 'alinear-una-sola-linea px-1',
          sortable: true
        },
        {
          key: 'campo_area',
          thClass: 'p-1 text-center alinear-medio',
          tdClass: 'alinear-una-sola-linea px-1',
          label: 'Campo Área',
          sortable: true
        },
        {
          key: 'cultivo_area',
          thClass: 'p-1 text-center alinear-medio',
          tdClass: 'alinear-una-sola-linea px-1',
          label: 'Cultivo',
          sortable: true
        },
        {
          key: 'firma_responsable',
          label: 'Firma Responsable',
          thClass: 'p-1 text-center alinear-medio',
          tdClass: 'alinear-una-sola-linea px-1 text-center',
          sortable: true
        },
        {
          key: 'fecha',
          label: 'Fecha',
          thClass: 'p-1 text-center alinear-medio',
          tdClass: 'alinear-una-sola-linea px-1',
          sortable: true
        },
        {
          key: 'con_evaluador',
          label: 'Evaluador',
          thClass: 'p-1 text-center alinear-medio',
          tdClass: 'alinear-una-sola-linea px-1',
          sortable: true
        },
        {
          key: 'estado',
          label: 'Estado',
          thClass: 'p-1 text-center alinear-medio',
          tdClass: 'alinear-una-sola-linea px-1',
        },
        {
          key: 'n_categorias',
          label: 'Sub-Categorías',
          thClass: 'p-1 text-center alinear-medio',
          tdClass: 'alinear-una-sola-linea px-1 text-center',
        },
      ],
      fieldsCategorias: [
        {
          key: 'categoria',
          label: 'Categoria',
          sortable: true
        },
        {
          key: 'respuesta',
          label: 'Respuesta',
          sortable: true
        },
        {
          key: 'hora_visita',
          label: 'Hora visita',
          sortable: true
        },
        {
          key: 'descripcion',
          label: 'Descripción',
          sortable: true
        },
        {
          key: 'accion_correctiva',
          label: 'acción correctiva',
          sortable: true
        },
        {
          key: 'plazo_dias_lo',
          label: 'plazo días',
          sortable: true
        },
        {
          key: 'fecha_lo',
          label: 'Fecha',
          sortable: true
        },
        {
          key: 'firma_conformidad',
          label: 'Firma Conformidad',
          sortable: true
        },
        {
          key: 'estado',
          label: 'Estado',
        },
        {
          key: 'fotos',
          label: 'N° de Fotos',
          sortable: true
        },
      ],
      items: [],
      itemsCategorias: [],
      status: [
        {
          '0': 'Activo',
          '1': 'Inactivo',
        },
        {
          '0': 'light-success',
          '1': 'light-danger',
        }
      ],
      validacion: null,
      estados: [
        {value: 0, text: "Activo"},
        {value: 1, text: "Inactivo"}
      ],
      codigo: '',
      descrip: '',
      nombre: '',
      estado: {value: 0, text: "Activo"},
      id: 0,
      tipo: 0,
      loading2: false,
      loading: false,
      loading_exp: false,
      loading_c: false,

      fotos: [],
      fotosFirma: "",

      itemsFiltro: [],
      empresaFiltro: [],
      empresa_filtro: [],
      fundoFiltro: [],
      fundo_filtro: [],
      etapaFiltro: [],
      etapa_filtro: [],
      campoFiltro: [],
      campo_filtro: [],
      zonaFiltro: [],
      zona_filtro: [],
      areaFiltro: [],
      area_filtro: [],
      evaluadorFiltro: [],
      evaluador_filtro: [],

      filtro: [
        {nombre: "empresa", valor: []},
        {nombre: "fundo", valor: []},
        {nombre: "etapa", valor: []},
        {nombre: "campo_area", valor: []},
        {nombre: "zona_inspeccion", valor: []},
        {nombre: "area", valor: []},
        {nombre: "con_evaluador", valor: []},
        {nombre: "fecha", valor: []},
      ],
      fechaFiltro: null,
    }
  },
  computed: {
    sortOptions() {
      // Create an options list from our fields
      return this.fields
          .filter(f => f.sortable)
          .map(f => ({
            text: f.label,
            value: f.key
          }))
    },
  },
  mounted() {
    this.traerEvaluaciones();
  },
  methods: {
    traerEvaluaciones(){
      const yo = this
      yo.loading = true

      const config = {
        method: 'get',
        url: '/bbss/visitascampo/arv/'
      };

      axiosIns(config)
          .then(function (response) {
            if(response.status === 200){
              yo.items = response.data;
              yo.empresaFiltro = [];
              yo.fundoFiltro = [];
              yo.etapaFiltro = [];
              yo.campoFiltro = [];
              yo.zonaFiltro = [];
              yo.areaFiltro = [];
              yo.evaluadorFiltro = [];
              yo.totalRows = yo.items.length

              for (let value of yo.items){
                if (value.empresa != null && value.empresa !== '' && value.empresa !== ' ' && value.empresa !== '  ') { yo.empresaFiltro.push(value.empresa) }
                if (value.fundo != null && value.fundo !== '' && value.fundo !== ' ' && value.fundo !== '  ') { yo.fundoFiltro.push(value.fundo) }
                if (value.etapa != null && value.etapa !== '' && value.etapa !== ' ' && value.etapa !== '  ') { yo.etapaFiltro.push(value.etapa) }
                if (value.campo_area != null && value.campo_area !== '' && value.campo_area !== ' ' && value.campo_area !== '  ') { yo.campoFiltro.push(value.campo_area) }
                if (value.zona_inspeccion != null && value.zona_inspeccion !== '' && value.zona_inspeccion !== ' ' && value.zona_inspeccion !== '  ') { yo.zonaFiltro.push(value.zona_inspeccion) }
                if (value.area != null && value.area !== '' && value.area !== ' ' && value.area !== '  ') { yo.areaFiltro.push(value.area) }
                yo.evaluadorFiltro.push(value.con_evaluador)
              }

              yo.empresaFiltro = [... new Set(yo.empresaFiltro)].sort()
              yo.fundoFiltro = [... new Set(yo.fundoFiltro)].sort()
              yo.etapaFiltro = [... new Set(yo.etapaFiltro)].sort()
              yo.campoFiltro = [... new Set(yo.campoFiltro)].sort()
              yo.zonaFiltro = [... new Set(yo.zonaFiltro)].sort()
              yo.areaFiltro = [... new Set(yo.areaFiltro)].sort()

              const hash = {};
              yo.evaluadorFiltro = yo.evaluadorFiltro.filter(function(current) {
                const exists = !hash[current.id];
                hash[current.id] = true;
                return exists;
              }).sort();

              yo.itemsFiltro = yo.items

            }

          })
          .catch(function (error) {
            console.log(error);
          })
          .finally(function (){
            yo.loading = false
          });
    },

    cPaginacion(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length
      this.currentPage = 1
    },
    cPaginacion_c(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRowsCategoria = filteredItems.length
      this.currentPage_c = 1
    },

    mostrarModal(tipo, id, codigo, descrip, nombre, estado){
      this.tipo = tipo
      this.estadoModal = true

      if (this.tipo === 1 ){
        this.infoModal.title = 'Registrar Empresa'
        this.infoModal.boton = 'Registar'
      }
      else if (this.tipo === 2 ){
        this.infoModal.title = 'Editar Empresa'
        this.infoModal.boton = 'Editar'

        this.id = id
        this.codigo = codigo
        this.descrip = descrip
        this.nombre = nombre

        this.estado = {value: parseInt(estado), text: estado === '0' ? 'Activo' : 'Inactivo'}
      }
    },

    mostrarNotificacion(titulo, icono, texto, variante){
      this.$toast({
            component: ToastificationContent,
            props:{
              title: titulo,
              icon: icono,
              text: texto,
              variant: variante
            }
          },
          {
            timeout: 5000
          })
    },

    resetInfoModal() {
      this.infoModal.title = ''
      this.infoModal.boton = ''
      this.estadoModal = false
    },

    validarFormulario() {
      const valid = this.$refs.form.checkValidity()
      this.validacion = valid
      return valid
    },

    resetModal() {
      this.codigo = ''
      this.descrip = ''
      this.nombre = ''
      this.estado = {value: 0, text: "Activo"}
      this.validacion = null
      this.resetInfoModal()
    },

    okModal(bvModalEvt) {

      bvModalEvt.preventDefault()

      this.enviarFormulario()
    },

    enviarFormulario() {
      // Exit when the form isn't valid
      if (!this.validarFormulario()) {
        return
      }

      // Hide the modal manually
      this.$nextTick(() => {
        var yo = this

        var data = JSON.stringify({
          "cod": yo.codigo,
          "descrip": yo.descrip,
          "nombre": yo.nombre,
          "estado": yo.estado.value.toString()
        });

        var url = this.tipo === 1 ? '/configuracion/empresas/crear/' : '/configuracion/empresas/editar/'+this.id
        var metodo = this.tipo === 1 ? 'post' : 'patch'

        var config = {
          method: metodo,
          url: url,
          headers: {
            'Content-Type': 'application/json'
          },
          data : data
        };

        axiosIns(config)
            .then(function (response) {

              if (response.status === 201 || response.status === 200){
                yo.traerEvaluaciones();

                if (yo.tipo === 1){
                  yo.mostrarNotificacion('Registro creado', 'CheckIcon', 'La empresa ' + response.data.cod + ' ha sido registrado correctamente', 'success')
                }else{
                  yo.mostrarNotificacion('Registro modificado', 'CheckIcon', 'La empresa ' + yo.codigo + ' ha sido modificado correctamente', 'success')
                }

              }else{
                yo.mostrarNotificacion('Error', 'BellIcon', JSON.stringify(response.data).toString(), 'danger')
              }

            })
            .catch(function (error) {
              console.log(error);
              yo.mostrarNotificacion('Error en el registro', 'BellIcon', error.toString(), 'danger')
            });

        this.estadoModal = false
      })
    },

    verCagetorias(categorias){
          const yo=this
          const id=categorias.id
          yo.loading_c = true
          const cardListEvaluacion = document.querySelector('#listEvaluaciones');
          const cardListCategoria = document.querySelector('#listCategorias');

          if (cardListCategoria.style.display === "none") {
            cardListEvaluacion.style.display = "none";
            cardListCategoria.style.display = "block";
          }

          const data = JSON.stringify(
              {
                "id":id
              }
          )

          const config = {
            method: 'post',
            url: '/bbss/checklist/exportar/filter/',
            headers: {
              'Content-Type': 'application/json'
            },
            data : data
          };

          axiosIns(config)
              .then(function (response) {
                if (response.status === 200) {





                  yo.itemsCategorias=response.data;
                  yo.totalRowsCategoria = yo.itemsCategorias.length;

                }
              })
              .catch(function (error) {
                console.log(error);

              })
              .finally(function () {
                yo.loading_c = false
              });

    },

    verFotos(fotos){
      this.estadoModal = true;
      this.fotos = fotos;
    },

    verFirma(fotos){
      this.estadoModalFirma = true;
      this.fotosFirma = fotos;
    },

    regresarInicio(){
      const cardListEvaluacion = document.querySelector('#listEvaluaciones');
      const cardListCategoria = document.querySelector('#listCategorias');


      if (cardListCategoria.style.display === "block") {
        cardListEvaluacion.style.display = "block";
        cardListCategoria.style.display = "none";
      }
    },

    descargarFile(){
      var yo = this
      this.loading2 = true
      var config = {
        method: 'post',
        url: '/ryr/registrosryr/exportar/',
        headers: {
          'Content-Type': 'application/json'
        },
        responseType: 'arraybuffer'
      };

      axiosIns(config)
          .then(function (response) {
            if (response.status === 200) {

              var fileURL = window.URL.createObjectURL(new Blob([response.data]));
              var fileLink = document.createElement('a');
              fileLink.href = fileURL;
              fileLink.setAttribute('download', 'RegistrosRyR.xlsx');
              document.body.appendChild(fileLink);
              fileLink.click();

              yo.$toast({
                    component: ToastificationContent,
                    props: {
                      title: 'Archivo creado',
                      icon: 'CheckIcon',
                      text: 'El archivo se creó satisfactoriamente.',
                      variant: 'success',
                    },
                  },
                  {
                    position: 'top-center',
                  })
            }
            else if(response.status === 204){
              yo.$toast({
                component: ToastificationContent,
                props: {
                  title: 'No existen registros',
                  icon: 'AlertTriangleIcon',
                  text: 'No se encontraron registros con los parámetros solicitados.',
                  variant: 'warning',
                },
              })
            }
          })
          .catch(function (error) {
            console.log(error);
            yo.$toast({
              component: ToastificationContent,
              props: {
                title: 'Error en la creación del archivo',
                icon: 'XIcon',
                text: 'Hubo un error en la creación del archivo, intentelo nuevamente en unos minutos.',
                variant: 'danger',
              },
            })
          })
          .finally(function () {
            yo.loading2 = false
          });
    },

    exportarFile(){
      const yo = this
      yo.loading_exp = true

      const config = {
        method: 'get',
        url: '/bbss/visitascamposf/',
        headers: {
          'Content-Type': 'application/json'
        },
        responseType: 'arraybuffer'
      };

      axiosIns(config)
          .then(function (response) {
            if (response.status === 200) {

              const fileURL = window.URL.createObjectURL(new Blob([response.data]));
              const fileLink = document.createElement('a');
              fileLink.href = fileURL;
              fileLink.setAttribute('download', "bbss.xlsx");
              document.body.appendChild(fileLink);
              fileLink.click();

              yo.$toast({
                    component: ToastificationContent,
                    props: {
                      title: 'Archivo creado',
                      icon: 'CheckIcon',
                      text: 'El archivo se creó satisfactoriamente.',
                      variant: 'success',
                    },
                  },
                  {
                    position: 'top-center',
                  })
            }
          })
          .catch(function (error) {
            console.log(error);
            yo.$toast({
                  component: ToastificationContent,
                  props: {
                    title: 'Error en la creación del archivo',
                    icon: 'XIcon',
                    text: 'Hubo un error en la creación del archivo, intentelo nuevamente en unos minutos.',
                    variant: 'danger',
                  },
                },
                {
                  position: 'top-center',
                })
          })
          .finally(function () {
            yo.loading_exp = false
          });
    },

    exportarFileV2(){
      const yo = this
      yo.loading_exp = true
      const data = JSON.stringify(
          {
            "datas":yo.itemsFiltro,
            "modulo":"arv"
          }
      )
      const config = {
        method: 'post',
        url: '/bbss/visitacampo/exportar/filter/',
        headers: {
          'Content-Type': 'application/json'
        },
        responseType: 'arraybuffer',
        data : data
      };

      axiosIns(config)
          .then(function (response) {
            if (response.status === 200) {
              const fileURL = window.URL.createObjectURL(new Blob([response.data]));
              const fileLink = document.createElement('a');
              fileLink.href = fileURL;
              const hoy = new Date();
              const fecha_hora = hoy.getFullYear() +''+ ( hoy.getMonth() + 1 ) +''+ hoy.getDate() +''+ hoy.getHours() +''+ hoy.getMinutes() +''+ hoy.getSeconds()

              fileLink.setAttribute('download', "BBSS ARV "+ fecha_hora +".xlsx");
              document.body.appendChild(fileLink);
              fileLink.click();

              yo.$toast({
                    component: ToastificationContent,
                    props: {
                      title: 'Archivo creado',
                      icon: 'CheckIcon',
                      text: 'El archivo se creó satisfactoriamente.',
                      variant: 'success',
                    },
                  },
                  {
                    position: 'top-center',
                  })
            }
          })
          .catch(function (error) {
            console.log(error);
            yo.$toast({
              component: ToastificationContent,
              props: {
                title: 'Error en la creación del archivo',
                icon: 'XIcon',
                text: 'Hubo un error en la creación del archivo, intentelo nuevamente en unos minutos.',
                variant: 'danger',
              },
            })
          })
          .finally(function () {
            yo.loading_exp = false
          });

    },

    realizarFiltro(cabecera, data){

      const yo = this
      yo.loading = true
      let spd = yo.items

      let filt = []
      let c = 0

      let fecha = yo.fechaFiltro
      let fechaInicio = ''
      let fechaFin = ''
      let fechaHoy = ''

      if(fecha !== null && fecha !== ''){
        fecha = fecha.split(' a ')
        if(fecha.length === 1){
          const [dia, mes, anio] = fecha[0].split('/');
          fechaInicio = new Date(+anio, mes - 1, +dia);
          fechaFin = new Date(+anio, mes - 1, +dia, 23, 59, 59);
        }else{
          const [dia, mes, anio] = fecha[0].split('/');
          const [dia1, mes1, anio1] = fecha[1].split('/');
          fechaInicio = new Date(+anio, mes - 1, +dia);
          fechaFin = new Date(+anio1, mes1 - 1, +dia1);
        }
      }

      for(const valor of yo.filtro){
        if (valor.nombre === cabecera){
          yo.filtro[c].valor = data
        }

        if(valor.nombre === 'fecha' && data.length === 0){
          yo.fechaFiltro = null
          yo.filtro[c].valor = data
        }

        c += 1;
      }

      for(const values of yo.filtro){
        for ( const column of values.valor ){
          spd.forEach(function(value) {
            if(values.nombre !== 'con_evaluador'){

              if(values.nombre === 'fecha' && column !== null){
                const [anios, mess, dias] = value.fecha.split('-')
                fechaHoy = new Date(+anios, mess - 1, +dias)

                if (fechaInicio !== '' && fechaFin !== ''){
                  if(fechaHoy.getTime() >= fechaInicio.getTime() && fechaHoy.getTime() <= fechaFin.getTime()){
                    filt.push(value)
                  }
                }

              }else{
                if (value[values.nombre] === column){
                  filt.push(value)
                }
              }

            }else{
              if (value[values.nombre]['id'] === column){
                filt.push(value)
              }
            }
          })
        }

        if(values.valor.length > 0){
          if(values.valor[0] !== null){
            spd = filt
            filt = []
          }

        }
      }

      yo.itemsFiltro = spd
      yo.loading = false
    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
@import '@core/scss/vue/libs/vue-flatpicker.scss';
.alinear-medio{
  vertical-align: middle!important;
  padding: 5px !important;
}

.alinear-una-sola-linea{
  white-space: nowrap!important;
}

.tablitabs{
  min-height: 58vh!important;
}

.tablitabs::-webkit-scrollbar {
  width: 1.35vh;
  height: 1.35vh;
}
.tablitabs::-webkit-scrollbar-track {
  background-color: rgba(171, 171, 171, 0.35);
  border-radius: 6px;
  position: absolute;
}
.tablitabs::-webkit-scrollbar-thumb {
  background-image: linear-gradient(47deg, #82868b, #9ca0a4);
  border-radius: 6px;
  position: absolute;
}
</style>
